export default "__VITE_ASSET__C36hdbFr__"